import gql from 'graphql-tag';

const ADD_MARKETING_ONLY_NOTE = gql` 
  mutation addMarketingOnlyNote($input: MarketingOnlyNoteInput!) {
    addMarketingOnlyNote(input: $input) {
      message
      code
      data
    }
  }
`;

export default ADD_MARKETING_ONLY_NOTE;